import * as Diff3 from './diff3.mjs';
globalThis.Diff3 = Diff3;
